export default [
  {
    id: 'spirals',
    title: 'Spiral Hangings',
    image: '/assets/images/hangings/Mercury.jpg',
    category: 'Wall Hangings',
    details: <div>
On this page, you'll get the only images on this site of pieces made from commercial fabrics (not my own hand-dyes); they're at the bottom of this page. I can't remember what prompted me to make the first one, but after that the idea had lodged firmly im my imagination and then really took off once I started dyeing fabric.
<br /><br />
So...that would put the first one about 1986! I'll take you through the pieces in reverse order, looking at the newest one first.
    </div>,
    variations: [
      {
        title: 'Round and Round',
        image: '/assets/images/hangings/RoundAndRound.jpg',
        description: <div>
          2004
          <br /><br />
          This hanging has quite a story behind it!
<br /><br />
A couple of years ago, I was contacted by a woman named Joanne Hammil, who lives near Boston. She is a musician, and writes rounds (think of Row Row Row Your Boat, only much more complicated and interesting.) She was in the process of producing 2 CDs of her rounds, catches, and partner songs, and was looking for cover art possibilities when she came accross my site. Now it just so happens that I love to sing, and am especially fond of rounds...so it seemed a good fit to use my work on the covers of her CDs. When Joanne looked at all of my work, she was most drawn to the spiral quilts and hangings, and so used Dance Doctor (seen further down on this page) and Stefanie's quilt (Pelagia Colorata by name) for the artwork. Several months later, we finally met, and in fact I got to sing some of her rounds in a concert in San Francisco.
<br /><br />

But wait; there's even more to this story! In the summer of 2004 I was married, and asked Joanne to write a round for the occaision. Julian (my now-husband) and I wrote the words, and Joanne made a wonderful round called Marriage at Fifty which she, I, and another friend sung at the wedding.

<br /><br />
This hanging is my thank-you to her for her song, It now hangs in her home, and is the inspiration for yet another round that Joanne has written! Check out Joanne's music at www.joannehammil.com .
        </div>
      },
      {
        title: 'Genesis',
        image: '/assets/images/hangings/Isis.jpg',
        description: <div>
          1997
          <br /><br />
Before this, there was Genesis. It originated as a commission for someone, who wanted a bedquilt in a spiral.
<br /><br />
When the center was together, it was clear that this did not want to be a bedquilt (the commissioners bought another quilt from me), but I had to figure out where it wanted to go. The large egg shape came as a surprise, appearing in a dream one night.  After that, it seemed clear to me that the piece was about beginnings, potential and creativity.
        </div>
      },
      {
        title: 'Mercury',
        image: '/assets/images/hangings/Mercury.jpg',
        description: <div>
          1996
          <br /><br />
Starting with the spiral in the center, the first spikes appeared of their own volition, and the work suddenly got much more playful! The name Mercury reflects the impish and spontaneous nature of this work. In addition to being the messenger of the gods and the conductor of souls to the afterlife, Mercury was a merry youth, inspiring riotous festivals. 
        </div>
      },
      {
        title: 'Dance Doctor',
        image: '/assets/images/hangings/dancer.jpg',
        description: <div>
          1994
          <br /><br />
          Here's the first spiral I made with hand-dyed cloth. All I knew when I started this piece was that I wanted to make a spiral. I simply chose two pieces of fabric to begin, and started in the center. I let the piece give me ideas as I went along...serendipity and I were collaborators here.
        </div>
      },
      {
        title: 'Eye of the Friendly Polypheme',
        image: '/assets/images/hangings/Polypheme.JPG',
        description: "My dear uncle named this one"
      },
      {
        title: 'Second Spiral',
        image: '/assets/images/hangings/SecondSpiral.JPG',
        description: "I never gave this one a name"
      }
    ]
  },
  {
    id: 'water-zigzag',
    title: 'Water Zigzag',
    image: '/assets/images/hangings/CockOfTheWalk.jpg',
    category: 'Wall Hangings',
    details: <div>
      Having made over 20 Water Zig Zag bedquilts over the years (go here if you want to see some), I've occaisionally used the same technique to make wallhanings. Different solutions appear to solve the design problems in these smaller pieces
    </div>,
    variations: [
      {
        title: 'Cock of the Walk',
        image: '/assets/images/hangings/CockOfTheWalk.jpg',
        description: <div>
2001
<br /><br />
After piecing the center of this hanging, I sensed a certain flamboyance emerging.  I encouraged that spirit by giving the piece a curved bottom and some crazy feathers on top.  After that, Cock of the Walk could really strut its stuff!
        </div>
      },
      {
        title: 'Shimmer',
        image: '/assets/images/hangings/Shimmer.jpg',
        description: <div>
          1997
          <br /><br />
          Here's a simpler way of setting the Water Zig Zag pattern. The border fabric has had salt sprinkled on it before drying flat on a table
        </div>
      },
      {
        image: '/assets/images/bedquilts/qWzz.jpg'
      }
    ]
  },
  {
    id: 'firefly',
    title: 'Firefly',
    image: '/assets/images/hangings/Firefly.jpg',
    category: 'Wall Hangings',
    details: <div>
          1995
          <br /><br />
          The starting point for this work was the large piece of orange-rose fabric which might be a swamp at sunset behind the lattice of an old library window. The name Firefly came from a twelve-year-old friend who saw the quilt in progress. This name inspired all sorts of questions - where are the fireflies? If they are the spirals above the window, are they inside or out? Or are we seeing the essence of just one firefly? 
    </div>,
    variations: [
      {
        title: "Firefly",
        image: '/assets/images/hangings/Firefly.jpg',
      },
    ]
  },
  {
    id: 'garden-gate',
    title: 'Garden Gate',
    image: '/assets/images/hangings/GardenGate.jpg',
    category: 'Wall Hangings',
    variations: [
      {
        title: "Garden Gate",
        image: '/assets/images/hangings/GardenGate.jpg',
        description: <div>
          1993
          <br /><br />
The center of this hanging is made from two pieces of fabric, each cut into strips. The one that appears "behind", the lighter one, is actually a monoprint: I smeared thickened dye on my table, and then carefully placed the fabric on top of my prepared painting (really, a finger painting!).
        </div>
      }
    ]
  },
  {
    id: 'venice',
    title: 'Venice',
    image: '/assets/images/hangings/Venice.jpg',
    category: 'Wall Hangings',
    variations: [
      {
        title: "Venice",
        image: '/assets/images/hangings/Venice.jpg',
        description: <div>
          1998?
          <br /><br />
          This piece also was essentially made of two pieces of fabric. The lighter of the two was a twist-dyed piece, and the darker an ombre.
          <br /><br />
          To see these individual fabric styles, visit the fabric techniques section.
        </div>
      }
    ]
  },
  {
    id: 'float',
    title: 'Float',
    image: '/assets/images/hangings/Float.jpg',
    category: 'Wall Hangings',
    variations: [
      {
        title: 'Float',
        image: '/assets/images/hangings/Float.jpg',
        description: <div>
          2005
          <br /><br />
          This piece started with the three vertical pieces which appear to be floating in the center. I found these pieces in my scrap drawer, and saw that they had once been a single piece, but I had torn it into these three separate pieces. I couldn't remember why, and obviously whatever the idea was, it didn't work, because they'd ended up as scrap. On my design wall I played with these, "auditioning" other pieces of cloth for quite some time before I found the right combination.
        </div>
      }
    ]
  },
  {
    id: 'womens-work',
    title: 'Women\'s Work',
    image: '/assets/images/hangings/WomensWork.jpg',
    category: 'Wall Hangings',
    variations: [
      {
        title: 'Women\'s Work',
        image: '/assets/images/hangings/WomensWork.jpg',
        description: <div>
          1995
          <br /><br />
          This piece is more closely related to the framed hangings than to most other large hangings.Except for its size, my thinking with it was very similar to the smaller stretched pieces.
          <br /><br />
          I've used large pieces of fabric dyed in a variety of ways. While designing the piece, I had the image of building a village with many separate elements living in harmony with each other. 
          <br /><br />
          Women's lives are often like this - a balancing of rich and varied kinds of work. 
        </div>
      }, {
        title: 'Women\'s Work - in situ',
        image: '/assets/images/other/WWatMoms.jpg',
      }
    ]
  },
  {
    id: 'sleeping-wing',
    title: 'Sleeping Wing',
    image: '/assets/images/hangings/SleepingWing.JPG',
    category: 'Wall Hangings',
    variations: [
      {
        title: 'Sleeping Wing',
        image: '/assets/images/hangings/SleepingWing.JPG',
        description: <div>
          1999
          <br /><br />
          This piece was a gift from the dyeing fairies!
          <br /><br />
          One afternoon I was dyeing something else (don't remember now what it was), and had some left-over dye. I slapped it on a couple pieces of cloth that I'd wrapped for arashi shibori. One of the pieces had been previously dyed, and in the other I used all the little bits of my leftovers. At the time, I thought of them as "lost pieces" -- didn't really expect them to be very interesting.
          <br /><br />
          Imagine my surprise when after washing, I had two deep, rich pieces of cloth which even liked each other! I kept the piecing simple, and set the shibori off with a bit of bright blue.
        </div>
      }
    ]
  },
  {
    id: 'open-hearth',
    title: 'Open Hearth/Heart\'s Flame',
    image: '/assets/images/hangings/OpenHearth.jpg',
    category: 'Wall Hangings',
    variations: [
      {
        title: 'Open Hearth',
        image: '/assets/images/hangings/OpenHearth.jpg',
        description: <div>
          2001
          <br /><br />
          I've always thought of this piece as second in a series, the first of which was produced more than ten years earlier! Heart's Flame was the first in the series, and I always wanted to work more with the idea of large pieces of fabric as the central focus, with the "right" fabrics surrounding them. As I get more and more involved in the dyeing, the piecing of my work can -or must!- be simpler.
        </div>
      },
      {
        title: 'Heart\'s Flame',
        image: '/assets/images/hangings/HeartsFlame.jpg',
        description: <div>
          1991
          <br /><br />
And here's the beginning of the series. When I made this piece, it was unlike anything else I'd done, but I was very fond of it. The idea of "setting" a single piece of cloth in the right environment was something that has stuck with me over the years.
        </div>
      }
    ]
  },
  {
    id: 'leafhenge',
    title: 'Leafhenge',
    image: '/assets/images/hangings/Leafhenge.jpg',
    category: 'Wall Hangings',
    variations: [
      {
        title: 'Leafhenge',
        image: '/assets/images/hangings/Leafhenge.jpg',
        description: <div>
          2004
          <br /><br />
          This piece was a long time in coming. I was asked to make a hanging using large pieces of my Artichoke cloth, so I first had to make the cloth. I dyed several pieces before I got what we wanted, and then searched my fabric collection and scrap drawers for the right surrounding pieces.
        </div>
      }
    ]
  },
  {
    id: 'waterside',
    title: 'Waterside',
    image: '/assets/images/hangings/Waterside.jpg',
    category: 'Wall Hangings',
    variations: [
      {
        title: 'Waterside',
        image: '/assets/images/hangings/WaterBigLite.jpg',
        description: <div>
          2003
          <br /><br />
          When I lived in Kentucky for a few months, I did a lot of dyeing, and the large piece of fabric in the hanging at left was a piece I made one night as I was trying to use up all the leftover dye of the day's work. The cloth is about 4 yards long, and after I washed it, I discovered that I liked it so much that I was loathe to cut it up at all!
          <br /><br />
          I kept the cloth for many years, waiting for an opportunity to use the fabric in its entirety. That time finally came, and Waterside is the resulting piece. It is magnificently displayed in the 2-story entryway of a home in Vermont.
        </div>
      }, {
        title: 'Waterside - in situ',
        image: '/assets/images/other/WatersideBelow.jpg',
      }

    ]
  },
  {
    id: 'inner-windows',
    title: 'Inner Windows',
    image: '/assets/images/hangings/Carter.jpg',
    category: 'Wall Hangings',
    details: <div>2000
      <br /><br />
    Below are three pieces I made for a house in Rochester NY, for a very specific site. The center piece is on a part of the wall (abbove the fireplace) that is about a foot further out than the two side walls. If you'd like to see the saga of these hangings, click here to view the archived pages of its progress from idea to actualization.</div>,
    variations: [
      {
        image: '/assets/images/hangings/Carter.jpg',
      },
    ]
  },
];
